import { InventoryPortalRoute } from "@interfaces";
import { SupportMain } from "../modules/SupportMain";
import { pathSupportMain } from "./routes.types";

export const routesSupport: InventoryPortalRoute[] = [
  {
    element: <SupportMain />,
    id: "supportMain",
    path: pathSupportMain,
  },
];

